import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CountryResponse } from '../../dto/response/master.response';
import { Injectable } from '@angular/core';
import { MasterService } from '../../service/master.service';
import { tap } from 'rxjs';
import { GetAllCountries } from '../actions/master.action';

export interface MasterModelState {
  countries?: CountryResponse[];
}

@State<MasterModelState>({
  name: 'masters',
  defaults: {
    countries: [] as CountryResponse[],
  },
})
@Injectable()
export class MasterState {
  constructor(private masterService: MasterService) {}

  @Selector()
  static countries(state: MasterModelState): CountryResponse[] | undefined {
    return state.countries;
  }

  @Selector()
  static countriesSelectorHtml(state: MasterModelState) {
    return state?.countries?.map((cn) => {
      return { label: cn?.emoji + ' ' + cn?.name, value: cn?.id };
    });
  }

  @Selector()
  static phoneCodeSelectorHtml(state: MasterModelState) {
    return state?.countries?.map((cn) => {
      return {
        label: cn?.emoji + ' ' + cn?.phone_code,
        value: '+' + cn?.phone_code,
        data: { class: cn?.iso2.toLowerCase(), code: '+' + cn?.phone_code },
      };
    });
  }

  @Action(GetAllCountries)
  getAllCountries(ctx: StateContext<MasterModelState>) {
    return this.masterService.fetchCountries().pipe(
      tap({
        next: (result: any) => {
          const state = ctx.getState();
          ctx.setState({
            ...state,
            countries: result,
          });
        },
        error: (err) => {
          throw new Error(err?.error?.message);
        },
      }),
    );
  }
}
